import { Modal } from "@quortex/front-common"
import { type MakeGenerics, useSearch } from "@tanstack/react-location"
import { QoEProviderModalContent } from "@/pages/ContentSteering/Settings/QoEProviderModalContent"

export type QoEProviderModalGenerics = MakeGenerics<{
  Search: {
    modal: "qoe_provider"
  }
}>

const AddSegmentModal = () => {
  const search = useSearch<QoEProviderModalGenerics>()

  return (
    <Modal data-testid="add-segment-modal" show={search.modal === "qoe_provider"}>
      <QoEProviderModalContent />
    </Modal>
  )
}

export default AddSegmentModal
